import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const helpers = createMultiStyleConfigHelpers(['icon']);

const baseStyle = () => ({});

const xs3 = () => ({
  icon: {
    boxSize: 4,
  },
});

const xs2 = () => ({
  icon: {
    boxSize: 5,
  },
});

const xs = () => ({
  icon: {
    boxSize: 6,
  },
});

const sm = () => ({
  icon: {
    boxSize: 7,
  },
});

const md = () => ({
  icon: {
    boxSize: 8,
  },
});

const lg = () => ({
  icon: {
    boxSize: 10,
  },
});

const xl = () => ({
  icon: {
    boxSize: 12,
  },
});

const xl2 = () => ({
  icon: {
    boxSize: 14,
  },
});

const xl3 = () => ({
  icon: {
    boxSize: 16,
  },
});

const xl4 = () => ({
  icon: {
    boxSize: 20,
  },
});

const inputXs = () => ({
  icon: {
    boxSize: 4,
  },
});

const inputSm = () => ({
  icon: {
    boxSize: 5,
  },
});

const inputMd = () => ({
  icon: {
    boxSize: 6,
  },
});

const inputLg = () => ({
  icon: {
    boxSize: 8,
  },
});

const buttonXs = () => ({
  icon: {
    boxSize: 3,
  },
});

const buttonSm = () => ({
  icon: {
    boxSize: 4,
  },
});

const buttonMd = () => ({
  icon: {
    boxSize: 5,
  },
});

const buttonLg = () => ({
  icon: {
    boxSize: 6,
  },
});

const selectOptionSm = () => ({
  icon: {
    boxSize: 5,
  },
});

const selectOptionMd = () => ({
  icon: {
    boxSize: 6,
  },
});

const selectOptionLg = () => ({
  icon: {
    boxSize: 7,
  },
});

const sizes = () => ({
  '3xs': xs3(),
  '2xs': xs2(),
  xs: xs(),
  sm: sm(),
  md: md(),
  lg: lg(),
  xl: xl(),
  '2xl': xl2(),
  '3xl': xl3(),
  '4xl': xl4(),

  inputXs: inputXs(),
  inputSm: inputSm(),
  inputMd: inputMd(),
  inputLg: inputLg(),

  buttonXs: buttonXs(),
  buttonSm: buttonSm(),
  buttonMd: buttonMd(),
  buttonLg: buttonLg(),

  selectOptionSm: selectOptionSm(),
  selectOptionMd: selectOptionMd(),
  selectOptionLg: selectOptionLg(),
});

const IconTheme = () =>
  helpers.defineMultiStyleConfig({
    baseStyle: baseStyle(),
    sizes: sizes(),
  });

export default IconTheme;
